var format = require("date-format");
const formatDate = (datum, timeToo = false) => {
  let newDate = new Date(datum);
  let formattedDate = datum ? (newDate ? (timeToo ? format("dd. MM. yyyy hh:mm", newDate) : format("dd. MM. yyyy", newDate)) : "") : datum;
  // console.log(formattedDate);
  return formattedDate;
};
export default formatDate;
